/**
 *  페이지 이름
 */
export const ACCOUNT_SELLER_PAGE_NAME = {
  SELLER_LIST: '판매자 리스트',
};

/**
 *  판매점 상태 SELECT 리스트
 */
export const ACCOUNT_SELLER_STATUS_SELECT_LIST = [
  {
    id: 0,
    name: '가입요청',
  },
  {
    id: 1,
    name: '입점거절',
  },
  {
    id: 2,
    name: '활성화',
  },
  {
    id: 3,
    name: '비활성화',
  },
];

/**
 *  판매점 태그 검수 상태 SELECT 리스트
 */
export const ACCOUNT_SELLER_TAG_REQUEST_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 2,
    name: '활성화',
  },
];

/**
 *  판매점 상태
 */
export const ACCOUNT_SELLER_STATUS = {
  REQUEST: 0,
  REJECT: 1,
  ACTIVE: 2,
  INACTIVE: 3,
  RE_REQUEST: 4,
};

/**
 *  판매점 상태 텍스트
 */
export const ACCOUNT_SELLER_STATUS_TEXT = {
  0: '가입요청',
  1: '입점거절',
  2: '활성화',
  3: '비활성화',
  4: '재 가입요청',
};

/**
 *  판매점 사업자 타입 SELECT 리스트
 */
export const ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST = [
  {
    id: 0,
    name: '개인',
  },
  {
    id: 1,
    name: '법인',
  },
];

/**
 *  판매자 사업자 타입 텍스트
 */
export const ACCOUNT_SELLER_BUSINESS_TYPE_TEXT = {
  0: '개인',
  1: '법인',
};

/**
 *  판매자 리스트가 없을 때 보여주는 텍스트
 */
export const ACCOUNT_SELLER_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 판매자 리스트가 없습니다.';
